module.exports = __webpack_public_path__ + "img/hokify-slogan.2954c00.svg";